"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentCompletedPie = void 0;
var react_1 = __importDefault(require("react"));
var Typo_1 = require("../Typo");
var styled_1 = require("./styled");
/**
 * @component Renders a percent completed pie component with customizable size, label, and animation.
 *
 * - The props object containing the following properties:
 * @prop {number} percent: The percentage to be displayed in the pie.
 * @prop {number} [size] The size of the pie in pixels. Defaults to 24.
 * @prop {{show: boolean, suffix?: string}} [label] An object containing a boolean indicating whether to show the percentage and an optional suffix string. e.g. {show: true, suffix: '%'}
 * @prop {React.ReactNode} [children] The content to be rendered inside the tooltip target element.
 * @return {ReactElement} The rendered percent completed pie component.
 */
var PercentCompletedPie = function (_a) {
    var percent = _a.percent, _b = _a.size, size = _b === void 0 ? 24 : _b, label = _a.label;
    var perUnit = 1.8;
    var transform = "rotate(".concat(parseInt(String(percent)) * perUnit, "deg)");
    return (react_1.default.createElement(styled_1.StyledContainer, null,
        react_1.default.createElement(styled_1.StyledWrapper, { size: size },
            react_1.default.createElement(styled_1.StyledCircle, null,
                react_1.default.createElement(styled_1.StyledMask, { size: size, transform: transform },
                    react_1.default.createElement(styled_1.StyledFill, { size: size, transform: transform, className: "fill" })),
                react_1.default.createElement(styled_1.StyledMask, { size: size, className: "mask half" },
                    react_1.default.createElement(styled_1.StyledFill, { size: size, transform: transform, className: "fill" }),
                    react_1.default.createElement(styled_1.StyledFill, { size: size, transform: transform, className: "fill fix" })))),
        (label === null || label === void 0 ? void 0 : label.show) && (react_1.default.createElement(Typo_1.LABEL, null, "".concat(percent).concat(label.suffix || '')))));
};
exports.PercentCompletedPie = PercentCompletedPie;
